import React from 'react'
import _ from 'underscore'
import { Pencil } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import Checkbox from '../checkbox'
import Textarea from '../textarea'
import store from '../../state/store'

class TutorProposerPosition extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      editing_motivation: false
    }

    this.motivationRef = React.createRef()
  }

  onAdd = () => {
    const params = {
      tutor: this.props.tutor_result.tutor,
      tutoring_job_position: this.props.tutoring_job_position,
      motivation: (this.props.tutor_subject || {}).justification || ''
    }

    store.emit('pending_tutor_proposals:add', params)
  }

  onRemove = () => {
    const params = {
      tutor_id: this.props.tutor_result.tutor.id,
      tutoring_job_position_id: this.props.tutoring_job_position.id
    }

    store.emit('pending_tutor_proposals:remove', params)
  }

  onToggleEditMotivation = () => {
    if (this.state.editing_motivation) {
      this.setState({editing_motivation: false})
    }
    else {
      this.onAdd()
      this.setState({editing_motivation: true})
    }
  }

  onMotivationChange = (value) => {
    const params = {
      tutor: this.props.tutor_result.tutor,
      tutoring_job_position: this.props.tutoring_job_position,
      motivation: value
    }

    store.emit('pending_tutor_proposals:motivation:update', params)
  }

  render() {
    const motivation = (this.props.tutor_proposal) ?
      this.props.tutor_proposal.motivation || ''
    :
      (this.props.tutor_subject || {}).justification || ''

    const proposed = !_.isEmpty(this.props.tutor_proposal)
    const can_tutor = !_.isEmpty(this.props.tutor_subject)

    return (
      <div className="grid gap-2 py-4 first:pt-0 last:pb-0">
        <div>
          {proposed ?
            <Checkbox name={this.props.tutoring_job_position.subject_name} classname={"checkbox checkbox-inline-block"} value='selected' checked={true} onChange={this.onRemove}/>
          :
            <Checkbox name={this.props.tutoring_job_position.subject_name} classname={"checkbox checkbox-inline-block"} value='selected' checked={false} onChange={this.onAdd}/>
          }
          {can_tutor ?
            <Badge variant="success" className="ml-2">Can Tutor</Badge>
            : null
          }
        </div>
        {this.state.editing_motivation ?
          <div className="grid gap-2">
            <Textarea ref={this.motivationRef} rows="4" value={motivation} onChange={this.onMotivationChange}/>
            <div className="flex justify-end">
              <Button size="sm" onClick={this.onToggleEditMotivation}>
                Close
              </Button>
            </div>
          </div>
        :
          <div className="flex items-start justify-between gap-2">
            <div>
              {motivation ?
                <span>{motivation}</span>
              :
                <Badge variant="warning">No Motivation</Badge>
              }
            </div>
            <Button variant="outline" size="icon-sm" aria-label="Edit motivation" onClick={this.onToggleEditMotivation}>
              <Pencil className="size-3.5"/>
            </Button>
          </div>
        }
      </div>
    )
  }
}

export default TutorProposerPosition
